module.exports = __webpack_public_path__ + "static/media/kellipic.e12b0ca7.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/bonus/kellipic.JPG
// module id = 57
// module chunks = 0